export default __webpack_public_path__ + "static/media/waerdenborch.93074d7e.png";